// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import {
    ListItemIcon, ListItemText,
    Menu, Stack,
    Tooltip
} from "@mui/material";

// App Imports

import {CheckBox} from "@mui/icons-material";
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {deleteDataPointValue, getDataPointValueByDataPointId} from "../../DataPointValue/DataPointValueClient";
import {changeDataPoint} from "../dataPointSlice";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import Typography from "@mui/material/Typography";


// Main Function
export default function DataPointValueListDrawer({fetchDataPointValues}) {


    // ****************** BEGIN STATES ****************************


    const [dataPointValues, setDataPointValues] = useState([]);

    // ****************** END STATES ****************************

    const dispatchData = useDispatch();
    const hideActions = useSelector((state) => state.userProfileSlc.value.rights) !== "Super User";
    const [deleteOpen, setDeleteOpen] = React.useState(false);

    // ****************** BEGIN STORE ****************************


    const selectorDataPointId = useSelector((state) => state.dataPointSlc.value.cdpvListId);
    const selectorDpvlDrawerState = useSelector((state) => state.dataPointSlc.value.cdpvListDrawerState);
    const selectorDataPointValueId = useSelector((state) => state.dataPointValueSlc.value.id);
    const selectorDataPointValueMcode = useSelector((state) => state.dataPointValueSlc.value.mcode);
    const selectorDataPointValueName = useSelector((state) => state.dataPointValueSlc.value.name);
    const selectorDataPointValueDescription = useSelector((state) => state.dataPointValueSlc.value.description);
    const displayId = useSelector((state) => state.dataPointSlc.value.id);
    const displayName = useSelector((state) => state.dataPointSlc.value.name);

    // ********************** END STORE ********************************


    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    // ****************** END REGISTER ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchDataPointValueList = () =>

    getDataPointValueByDataPointId(selectorDataPointId)
            .then(data => {
                console.log("this as my response");
                console.log(data);
                setDataPointValues(data);
            });


    useEffect(() => {
        fetchDataPointValueList();
    }, [ useSelector((state) => state.dataPointSlc.value.cdpvListDrawerState)===true]);

    // ****************** END FETCH ****************************


    const renderDataPointValues = dataPointValues => {
        if (dataPointValues.length <= 0) {
            return "No Data";
        }}


    const removeDataPointValue = () => {
        deleteDataPointValue(selectorDataPointValueId).then(() => {
            setDeleteOpen(false);
            dispatchData(changeDataPoint({dpGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }

    const handleMousedRow = (dataPoints) => {

        console.log(' data from clicked row');
        console.log(dataPoints);
        dispatchData(changeDataPoint({id: dataPoints.id,
            mcode: dataPoints.mcode, name: dataPoints.name,
            description: dataPoints.description,status:dataPoints.status, dataType: dataPoints.dataType,
            piiClassification: dataPoints.piiClassification, allowMany: dataPoints.allowMany}));
    };
    function CrudMenu() {

        const [anchorEl, setAnchorEl] = React.useState(null);

        const isMenuOpen = Boolean(anchorEl);

        const handleCrudMenuOpen = (event) => {
            setAnchorEl(event.currentTarget);
        };

        function handleMenuClose()  {
            setAnchorEl(null);

        };

        const handleEdit = () => {
            dispatchData(changeDataPoint({dpDrawerState: true,
                dpDrawerMode: "Edit"}));
        };

        const crudId = 'primary-search-account-menu';

        const renderMenu = (
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                id={crudId}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={isMenuOpen}
                onClose={handleMenuClose}
            >
                <MenuItem
                    onClick={handleEdit}
                >
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Edit</ListItemText>
                </MenuItem>
                <MenuItem onClick={removeDataPointValue}>
                    <ListItemIcon>
                        <DeleteOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Delete</ListItemText>
                </MenuItem>
            </Menu>
        );
        return (
            <div>
                <IconButton
                    size="large"
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={crudId}
                    aria-haspopup="true"
                    onClick={handleCrudMenuOpen}
                    color="inherit"
                >
                    <MoreVertIcon  color="primary" fontSize="small"/>
                </IconButton>
                {renderMenu}
            </div>
        );
    }

    // ****************** BEGIN CRUD ***********************************

    // ****************** END CRUD ***********************************

    function closeDataPointValueListDrawer() {
        dispatchData(changeDataPoint({cdpvListId: 0, cdpvListDrawerState: false}));
    };


    // ****************** BEGIN DRILLDOWN ****************************

    // ****************** END DRILLDOWN ****************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1, pl: 1}}>
                    <Tooltip title={"Add Data Point Value"}>
                        <AddCircleOutlineIcon
                            sx={{mr: 3, mb: .5, verticalAlign: 'bottom'}}
                            fontSize="medium" color={'primary'}
                            // onClick={() => handleAdd()}
                        />
                    </Tooltip>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton sx={{mr: 3}} />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

// ********************END TOOLBAR ********************************


    // ****************** BEGIN COLUMNS ****************************

    const columns = fetchDataPointValues => [

        {
            field: "more",
            headerName: '',
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: hideActions,
            renderCell: (dataPoints) => {
                return (
                    <div onMouseEnter = {() => handleMousedRow(dataPoints.row)}>
                        <CrudMenu/>
                    </div>
                );
            }
        },
        {    field: 'id',
            headerName: 'ID',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 60,
            hide: false,
        },

        {
            field: 'name',
            headerName: 'Name',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            editable: true,
            width: 500,
            renderCell: (dataPointValues) => {
                return (
                    <p >
                        {dataPointValues.row.name} </p>
                );
            }

        },
        {
            field: 'description',
            headerName: 'Description',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            editable: true,
            width: 400,
            renderCell: (dataPointValues) => {
                return (
                    <p >
                        {dataPointValues.row.description} </p>
                );
            }
        },
        {
            field: 'exceptionInd',
            headerName: 'Exception',
            formatter: CheckBox,
        },
        {
            field: 'ordinalNumber',
            headerName: 'Order',
            description: 'This column has a value getter and is not sortable.',
            width: 100,
        },
        {
            field: 'status',
            headerName: 'Status',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'createdOn',
            headerName: 'createdOn',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'createdBy',
            headerName: 'createdBy',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'lastModifiedOn',
            headerName: 'lastModifiedOn',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'lastModifiedBy',
            headerName: 'lastModifiedBy',
            description: '',
            width: 100,
            hide: true
        },
    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                PaperProps={{
                    sx: { width: 1200 },
                }}
                anchor='right'
                open={selectorDpvlDrawerState}
                initialState={{open: false}}
                onClose={closeDataPointValueListDrawer}
            >
                <Box style={{cursor:'pointer'}} sx= {{pl: 2}}>
                <h1 onClick={() => closeDataPointValueListDrawer()}>Data Point Values</h1>
                    <Stack direction="row" spacing={1}>
                        <Typography component="span">id:</Typography>
                        <Typography component="span" fontWeight="bold">{displayId}</Typography>
                        <Box sx={{ ml: 6 }} /> {/* Adds extra spacing before 'name:' */}
                        <Typography component="span">name:</Typography>
                        <Typography component="span" fontWeight="bold">{displayName}</Typography>
                    </Stack>
                </Box>
                <DataGrid
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={{
                    }}
                    aria-label={"DataPointValues"}
                    rows={dataPointValues}
                    disableDensitySelector={true}
                    disableColumnSelector={true}
                    columns={columns(fetchDataPointValueList)}
                    density={"compact"}
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    rowKey={dataPointValue => dataPointValue.id}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooter,
                    }}
                />

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
